module.exports = __webpack_public_path__ + "img/keyboard_3.fb568150.png";